export {
    default as StartScreen,
    StartScreenProps,
} from './start-screen';
